import React from 'react';
import { FiShoppingCart, FiTerminal, FiPhone } from 'react-icons/fi';
import { LuFuel } from 'react-icons/lu';
import { MdLocalParking } from 'react-icons/md';

export function ChannelsStep({
  selectedChannels,
  onToggleChannel,
}) {
  const channels = [
    {
      id: 'ecommerce',
      label: 'E-commerce',
      icon: <FiShoppingCart className="w-6 h-6" />,
    },
    {
      id: 'in-store',
      label: 'In-store',
      icon: <FiTerminal className="w-6 h-6" />,
    },
    {
      id: 'fuel',
      label: 'Pay at pump',
      icon: <LuFuel className="w-6 h-6" />,
    },
    {
      id: 'unattended',
      label: 'Unattended',
      icon: <MdLocalParking className="w-6 h-6" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
      {channels.map((channel) => (
        <button
          key={channel.id}
          onClick={() => onToggleChannel(channel.id)}
          className={`p-6 rounded-lg border-2 transition-all ${
            selectedChannels.includes(channel.id)
              ? 'border-blue-500 bg-blue-50'
              : 'border-gray-200 hover:border-blue-200'
          }`}
        >
          <div className="flex items-center space-x-4">
            <div
              className={`p-3 rounded-full ${
                selectedChannels.includes(channel.id)
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-100 text-gray-500'
              }`}
            >
              {channel.icon}
            </div>
            <div className="text-left">
              <h3 className="font-medium text-gray-900">{channel.label}</h3>
              <p className="text-sm text-gray-500">
                {getChannelDescription(channel.id)}
              </p>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}

function getChannelDescription(channel) {
  switch (channel) {
    case 'ecommerce':
      return 'Online payments through your website or app';
    case 'in-store':
      return 'In-person payments using physical terminals';
    case 'fuel':
      return 'Pay at pump for fuel stations';
    case 'unattended':
      return 'Self-service kiosks and vending machines';
    default:
      return '';
  }
}